module.exports = __webpack_public_path__ + "media/V87.70ae123f.mp4";